<template>
  <!-- 首页顶部导航科室分类 内容为视频列表 -->
  <div id="office-kind">
    <div class="box-wrapper" v-for="(item,index) in itemData" :key="index">
      <video-box :item='item'></video-box>
    </div>
  </div>
</template>
<script>
import VideoBox from '../public/VideoBox'
import { channelList } from '@/api/index'
// import LoadeMore from '../public/LoadeMore'
export default {
  data () {
    return {
      itemData: []
    }
  },
  props: {
    departmentId: {
      type: String
    }
  },
  watch: {
    departmentId (n, o) {
      this.fetch()
    }
  },
  components: {
    'video-box': VideoBox
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      let params = {
        department_id: this.departmentId
        // number: 1
      }
      let url = `${channelList}?department_id=${params.department_id}`
      this.$http.get(url, this.$ObjToFd(params)).then(res => {
        if (res.data.code == '0') {
          this.itemData = res.data.data.videoList
          if(params.department_id){
            // localStorage.setItem('navTitle', res.data.data.videoList[0].title)
            this.$emit('childsend', res.data.data.videoList[0].title)
          }
        }
      })
    }
  }
}
</script>

<style lang="postcss">
#office-kind{
  width: 100%;
  display: inline-block;
  & .box-wrapper{
    margin: 48px 30px;
    border-radius:8px;
    box-shadow:0px 3px 6px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/OfficeKinds.vue